import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { RadioGroup } from '@atlaskit/radio';
import SectionMessage from '@atlaskit/section-message';
import { ChoiceQuestionStyles } from '../common/commonStyles';
import { ChoiceFieldWrapper, ChoicePlaceholder } from '../common/questionWrappers';
import { EditOtherOption } from './EditOtherOption';
export const EditSingleChoice = ({
  id,
  options,
  value,
  isInvalid,
  isRequired,
  onChange,
  hasOtherOption,
  otherOptionSelected,
  otherOptionText,
  onOtherOptionTextChange,
  warningMessage
}) => {
  var _value$value;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ChoiceFieldWrapper, {
    isDisabled: false,
    isInvalid: isInvalid
  }, /*#__PURE__*/React.createElement("div", null, options !== null && options !== void 0 && options.length ? /*#__PURE__*/React.createElement(ChoiceQuestionStyles, null, /*#__PURE__*/React.createElement(RadioGroup, {
    name: id,
    options: fg('proforma_cascading_fields_radio_fix') ? options.map(option => ({
      label: option.label,
      value: option.value
    })) : options,
    value: (_value$value = value === null || value === void 0 ? void 0 : value.value) !== null && _value$value !== void 0 ? _value$value : null // When `undefined` this is an uncontrolled component and uses internal state.
    ,
    onChange: onChange,
    "aria-labelledby": fg('proforma_a11y_group_controls_for_screen_reader') ? id : undefined,
    isRequired: fg('proforma_a11y_mandatory_fields') ? isRequired : undefined
  })) : /*#__PURE__*/React.createElement(ChoicePlaceholder, null), hasOtherOption && otherOptionSelected && /*#__PURE__*/React.createElement(EditOtherOption, {
    dropdown: false,
    value: otherOptionText,
    isDisabled: !otherOptionSelected,
    onChange: onOtherOptionTextChange,
    id: fg('proforma_add_unique_id_for_textarea_fields') ? id : undefined
  }))), warningMessage && /*#__PURE__*/React.createElement(SectionMessage, {
    appearance: "warning"
  }, warningMessage));
};